/**
 * @prettier
 */
import {get} from '../utils/ajaxHelper';

/* eslint-disable complexity */
function pricing({
    listingId,
    site,
    arrival,
    departure,
    adults,
    children,
    pets,
    isOnlineBookable,
    acceptsHomeAwayPayments,
    unitId,
    useMockData
}) {
    pets = pets ? 1 : 0; // PDS wants an integer, we store a boolean
    const requestMarker = window && window.debugLog && window.debugLog.requestMarker;
    const variant = window && window.debugLog && window.debugLog.variant;

    let url = `/pdp/pricing?listingIds=${listingId}&site=${site}&arrival=${arrival}&departure=${departure}&adults=${adults}&children=${children}&pets=${pets}&isOnlineBookable=${isOnlineBookable}&acceptsHomeAwayPayments=${acceptsHomeAwayPayments}&unitId=${unitId}`;
    url = requestMarker ? `${url}&originRequestMarker=${requestMarker}` : url;
    url = variant ? `${url}&variant=${variant}` : url;
    url = useMockData ? `${url}&useMockData=true` : url;
    // Consider handling the ajax callback here, and mutating the data to something standard.

    // Until this is production ready, we are going to add Pricing calls to the debugLog
    // for easy parusal.
    window && window.log && window.log(`[PRICING] requestMarker=${requestMarker}  url=${url}`); // eslint-disable-line

    const request = get(url);

    return request;
}
/* eslint-enable complexity */

export default pricing;
export {pricing};
